import React, { useState, useEffect } from 'react';
import { DollarSign, ArrowDownCircle, Clock, CheckCircle, ExternalLink, Wallet, Building, Zap } from 'lucide-react';

const API = 'https://api.naijapredict.net';

export default function Payouts() {
  const [tab, setTab]         = useState('withdraw');
  const [method, setMethod]   = useState('usdc');
  const [loading, setLoading] = useState(false);
  const [earnings, setEarnings] = useState({ pending: 12.45, total: 48.20, history: [] });

  const HISTORY = [
    { id:1, amount:5.20,  date:'Aug 1, 2026',  method:'USDC Wallet', status:'completed', tx:'0x123...abc' },
    { id:2, amount:8.40,  date:'Jul 28, 2026', method:'OPay',        status:'completed', tx:null },
    { id:3, amount:3.10,  date:'Jul 20, 2026', method:'USDC Wallet', status:'completed', tx:'0x456...def' },
  ];

  async function withdraw() {
    setLoading(true);
    setTimeout(() => { setLoading(false); alert('Withdrawal initiated! Processing within 24hrs.'); }, 2000);
  }

  return (
    <div>
      <div style={{ marginBottom:28 }}>
        <h1 style={{ fontSize:28, fontWeight:800, fontFamily:"'Syne',sans-serif", marginBottom:4 }}>Payouts</h1>
        <p style={{ fontSize:14, color:'#4a5a63' }}>Withdraw your creator royalties to bank or USDC wallet</p>
      </div>

      {/* Earnings Overview */}
      <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fit,minmax(200px,1fr))', gap:16, marginBottom:24 }}>
        {[
          [Zap,         'Available to Withdraw', `$${earnings.pending.toFixed(2)}`, '#00c566'],
          [DollarSign,  'Total Earned',          `$${earnings.total.toFixed(2)}`,   '#f5c842'],
          [CheckCircle, 'Total Withdrawn',        `$${(earnings.total-earnings.pending).toFixed(2)}`, '#4a5a63'],
        ].map(([Icon,label,val,color])=>(
          <div key={label} className="card">
            <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:12 }}>
              <Icon size={18} color={color}/>
              <span style={{ fontSize:11, color:'#4a5a63', fontWeight:600 }}>USDC</span>
            </div>
            <div style={{ fontSize:26, fontWeight:800, fontFamily:"'Syne',sans-serif", color }}>{val}</div>
            <div style={{ fontSize:12, color:'#4a5a63', marginTop:4 }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:8, marginBottom:20 }}>
        {['withdraw','history'].map(t=>(
          <button key={t} onClick={()=>setTab(t)} className="btn" style={{ padding:'8px 20px', fontSize:13, background:tab===t?'rgba(0,197,102,.1)':'rgba(255,255,255,.04)', color:tab===t?'#00c566':'#4a5a63', border:tab===t?'1px solid rgba(0,197,102,.2)':'1px solid rgba(255,255,255,.08)', textTransform:'capitalize' }}>
            {t==='withdraw'?'Withdraw':'History'}
          </button>
        ))}
      </div>

      {tab==='withdraw' && (
        <div style={{ maxWidth:520 }}>
          <div className="card" style={{ marginBottom:16 }}>
            <div style={{ fontSize:14, fontWeight:700, marginBottom:16 }}>Withdrawal Method</div>
            <div style={{ display:'flex', flexDirection:'column', gap:10 }}>
              {[
                { id:'usdc',  Icon:Wallet,   title:'USDC Wallet',        desc:'Send to your Ethereum wallet address' },
                { id:'bank',  Icon:Building, title:'Nigerian Bank (NGN)', desc:'Via Flutterwave — OPay, GTBank, Access, etc.' },
              ].map(({id,Icon,title,desc})=>(
                <div key={id} onClick={()=>setMethod(id)} style={{ display:'flex', alignItems:'center', gap:14, padding:14, borderRadius:12, border:`1px solid ${method===id?'rgba(0,197,102,.3)':'rgba(255,255,255,.06)'}`, background:method===id?'rgba(0,197,102,.04)':'rgba(255,255,255,.02)', cursor:'pointer' }}>
                  <div style={{ width:40, height:40, borderRadius:10, background:method===id?'rgba(0,197,102,.12)':'rgba(255,255,255,.04)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                    <Icon size={18} color={method===id?'#00c566':'#4a5a63'}/>
                  </div>
                  <div>
                    <div style={{ fontSize:14, fontWeight:600, color:method===id?'#00c566':'#e8eaeb' }}>{title}</div>
                    <div style={{ fontSize:12, color:'#4a5a63' }}>{desc}</div>
                  </div>
                  <div style={{ marginLeft:'auto', width:18, height:18, borderRadius:'50%', border:`2px solid ${method===id?'#00c566':'#2a3540'}`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                    {method===id && <div style={{ width:8, height:8, borderRadius:'50%', background:'#00c566' }}/>}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="card" style={{ marginBottom:16 }}>
            <div style={{ fontSize:14, fontWeight:700, marginBottom:14 }}>
              {method==='usdc'?'Wallet Address':'Bank Details'}
            </div>
            {method==='usdc' ? (
              <div>
                <label>USDC WALLET ADDRESS (ETHEREUM)</label>
                <input placeholder="0x..." style={{ fontFamily:'monospace' }}/>
                <div style={{ fontSize:11, color:'#4a5a63', marginTop:6 }}>Ensure this is an Ethereum network address</div>
              </div>
            ) : (
              <div style={{ display:'flex', flexDirection:'column', gap:14 }}>
                <div>
                  <label>BANK NAME</label>
                  <select><option>OPay</option><option>GTBank</option><option>Access Bank</option><option>Zenith Bank</option><option>Moniepoint</option></select>
                </div>
                <div>
                  <label>ACCOUNT NUMBER</label>
                  <input placeholder="10-digit account number" maxLength={10} inputMode="numeric"/>
                </div>
                <div>
                  <label>ACCOUNT NAME</label>
                  <input placeholder="Auto-filled after verification" readOnly style={{ color:'#4a5a63' }}/>
                </div>
              </div>
            )}
          </div>

          <div className="card" style={{ marginBottom:20, background:'rgba(255,255,255,.02)' }}>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:14, marginBottom:8 }}>
              <span style={{ color:'#4a5a63' }}>Available Balance</span>
              <span style={{ fontWeight:700 }}>${earnings.pending.toFixed(2)} USDC</span>
            </div>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:14, marginBottom:8 }}>
              <span style={{ color:'#4a5a63' }}>Processing Fee</span>
              <span style={{ color:'#00c566', fontWeight:600 }}>FREE</span>
            </div>
            {method==='bank' && (
              <div style={{ display:'flex', justifyContent:'space-between', fontSize:14, marginBottom:8 }}>
                <span style={{ color:'#4a5a63' }}>Exchange Rate</span>
                <span style={{ fontWeight:600 }}>$1 = ₦1,650</span>
              </div>
            )}
            <div style={{ height:1, background:'rgba(255,255,255,.06)', margin:'10px 0' }}/>
            <div style={{ display:'flex', justifyContent:'space-between', fontSize:15 }}>
              <span style={{ fontWeight:700 }}>You Receive</span>
              <span style={{ fontWeight:800, color:'#00c566' }}>
                {method==='usdc'
                  ? `$${earnings.pending.toFixed(2)} USDC`
                  : `₦${(earnings.pending*1650).toLocaleString()}`
                }
              </span>
            </div>
          </div>

          <button onClick={withdraw} disabled={loading||earnings.pending<1} className="btn btn-primary" style={{ width:'100%', padding:14, fontSize:15, display:'flex', alignItems:'center', justifyContent:'center', gap:8, opacity:earnings.pending<1?0.5:1 }}>
            <ArrowDownCircle size={18}/>
            {loading ? 'Processing...' : `Withdraw $${earnings.pending.toFixed(2)} USDC`}
          </button>
        </div>
      )}

      {tab==='history' && (
        <div className="card">
          <div style={{ fontSize:15, fontWeight:700, marginBottom:16 }}>Withdrawal History</div>
          {HISTORY.length === 0 ? (
            <div style={{ textAlign:'center', padding:32, color:'#4a5a63' }}>No withdrawals yet</div>
          ) : HISTORY.map(h=>(
            <div key={h.id} style={{ display:'flex', alignItems:'center', gap:14, padding:'14px 0', borderBottom:'1px solid rgba(255,255,255,.04)' }}>
              <div style={{ width:40, height:40, borderRadius:10, background:'rgba(0,197,102,.08)', display:'flex', alignItems:'center', justifyContent:'center' }}>
                <CheckCircle size={18} color="#00c566"/>
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:14, fontWeight:600 }}>{h.method}</div>
                <div style={{ fontSize:12, color:'#4a5a63', display:'flex', alignItems:'center', gap:4 }}>
                  <Clock size={10}/>{h.date}
                </div>
              </div>
              <div style={{ textAlign:'right' }}>
                <div style={{ fontSize:15, fontWeight:700, color:'#00c566' }}>${h.amount.toFixed(2)}</div>
                {h.tx && (
                  <a href={`https://sepolia.etherscan.io/tx/${h.tx}`} target="_blank" rel="noreferrer"
                    style={{ fontSize:11, color:'#4a5a63', display:'flex', alignItems:'center', gap:3, justifyContent:'flex-end', marginTop:2 }}>
                    <ExternalLink size={10}/>View TX
                  </a>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
